import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { useContractConsentProvider } from '../ContractConsent.Hooks';

export type ContractConsentManualAcceptanceForm = Api.Core.ContractConsent.ManualAcceptance.IParams &
  Api.Core.ContractConsent.ManualAcceptance.IRequest;
export default function ContractConsentManuallyAcceptConsent() {
  const { lang } = getLocales();
  const { selected, pageRouter, isEnabled, manuallyAccept } = useContractConsentProvider();

  if (!isEnabled(selected)) {
    pageRouter.updateParams({});
    return null;
  }

  return (
    <ModalForm<ContractConsentManualAcceptanceForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.manuallyAcceptConsent}
      default={{
        id: selected?.id,
      }}
      onCancel={() => pageRouter.updateParams({})}
      onSubmit={async ({ id, reasonForManualAcceptance, noteForManualAcceptance }) => {
        await manuallyAccept({ id, reasonForManualAcceptance, noteForManualAcceptance });
      }}
      validation={(data, errors) => {
        if (!data.reasonForManualAcceptance) errors.reasonForManualAcceptance = lang.required;
      }}
      render={({ form }) => (
        <FormWrapper>
          <TextInput
            name="reasonForManualAcceptance"
            label={lang.reason}
            type="text"
            value={form.data?.reasonForManualAcceptance}
            error={form.errors?.reasonForManualAcceptance}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
          <TextInput
            name="noteForManualAcceptance"
            label={lang.notes}
            type="text"
            value={form.data?.noteForManualAcceptance}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
        </FormWrapper>
      )}
    />
  );
}
